module.exports = __webpack_public_path__ + "static/media/brand-filter.8cca0fa6.svg";